import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\"full-screen-error\">\n  <NotFound />\n</div>",{ moduleName: "frontend/templates/four-oh-four.hbs" })